import { Box } from '@mui/material';
import { useEffect, useMemo } from 'react';
import { useForm } from 'react-hook-form';
import { useOwnUserNode } from '/@/hooks/nodes';
import { useCurrentCampaignYear } from '/@/hooks/zones';
import { _ } from '/@/locale';
import { getNodeScopeFilters } from '/@/utils/node-scope';
import DashboardSubheader from '../../../components/dashboard-sub-header';
import CropSurfaceReportRankingDashboardCard from '../../../growers/components/crop-surface-report-ranking-dashboard-card';
import GrowersRankingReportDashboardCard from '../../components/growers-ranking-report-dashboard-card';
import HybridRankingReportDashboardCard from '../../components/hybrids-ranking-report-dashboard-card';
import RVsList from '../../components/rv-list';

export const RVPastReportsDashboard = () => {
    const rvUserNodeQuery = useOwnUserNode();
    const currentCampaignYear = useCurrentCampaignYear();
    const previousCampaignYear = useMemo(() => {
        return currentCampaignYear !== null ? currentCampaignYear - 1 : null;
    }, [currentCampaignYear]);
    const form = useForm<{
        year: number;
    }>({
        defaultValues: {
            year: previousCampaignYear ?? new Date().getFullYear() - 1,
        },
    });

    // Update form value when previousCampaignYear becomes available
    useEffect(() => {
        if (previousCampaignYear !== null) {
            form.setValue('year', previousCampaignYear);
        }
    }, [previousCampaignYear, form]);
    const year = form.watch('year');

    return (
        <>
            <DashboardSubheader
                title={_('Reportes de campaña')}
                subtitle={_('Accedé a una visión integral de tus RVs para brindar el asesoramiento que necesitan.')}
                form={form}
            />
            <Box sx={{ display: 'grid', gridTemplateColumns: { md: '1fr 1fr 1fr', xs: '1fr' }, gap: 2 }}>
                <CropSurfaceReportRankingDashboardCard year={year} nodeScope={getNodeScopeFilters('rvs')} />
                <GrowersRankingReportDashboardCard year={year} />
                <HybridRankingReportDashboardCard year={year} />
            </Box>
            {rvUserNodeQuery.data && <RVsList tab='past-reports' year={year} />}
        </>
    );
};
